import { FormEvent, useState } from 'react';
import { IValidation } from './final-xm-validation';
import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Label } from 'react-bootstrap';
import UploadFile from '@nkr/views/center-admin/billing/view-edit/upload-file';

interface IProps {
    upload: File,
    isList: boolean,
    onUploadChange: (upload: File) => void
}

const UploadSerologyContents = (props: IProps) => {
    const [uploadValid, setUploadValid] = useState(false);
    
    const handleSelectFile = (file: File) => {
        //check if file is valid prior to making attempt

        props.onUploadChange(file);
    };

    return (
        <Form horizontal>
            <FormGroup>
                <Col xs={12} lg={4} componentClass={ControlLabel}>
                    Upload Results:
                </Col>
                <Col xs={12} lg={8}>
                    <FormControl.Static style={{ display: props.isList ? 'flex' : null }}>
                        <UploadFile
                            elementName='finalXmFile'
                            valid={true}
                            disable={false}
                            accept='.pdf'
                            onSelectFile={handleSelectFile}
                        />

                        {props.upload != null && (
                            <div style={{ marginLeft: 5, paddingTop: 3 }}>Selected File: <Label style={{ fontSize: '90%' }}>{props.upload.name}</Label></div>
                        )}
                    </FormControl.Static>
                </Col>

                {!uploadValid && (
                    <Col xs={12} lg={8} lgOffset={4}>
                        <HelpBlock>This is required</HelpBlock>
                    </Col>
                )}
            </FormGroup>
        </Form>
    );
}

export default UploadSerologyContents;